export default function phoneWithPlus(phone) {
  if (phone && !phone.startsWith('+')) {
    return `+${phone}`;
  }

  return phone;
}
